import { Pipe, PipeTransform } from '@angular/core';
import { IAddressModel } from '@libs/vc-org-lib';

/**
 * @description
 *
 * This pipe transforms an array of address objects (IAddressModel[]) into a single string representation.
 * Each address is formatted as "addressLine1, addressLine2, city, province, country - postalCode"
 * and the resulting addresses are joined together with commas.
 *
 * If the input array is empty or null, an empty string is returned.
 *
 * @usageNotes
 *
 * ```
 * {{ text | address }}
 * ```
 *
 * @param addresses - Array of IAddressModel objects containing address details.
 * @returns A string containing all formatted addresses, separated by commas.
 */

@Pipe({
    name: 'address',
    standalone: true,
})
export class AddressPipe implements PipeTransform {
    public transform(addresses: IAddressModel[]): string {
        if (!addresses) {
            return '';
        }
        const addressesStr: string[] = [];
        addresses.forEach((address: IAddressModel) => {
            let addressStr = address.addressLine1;
            if (address.addressLine2) {
                addressStr += ', ' + address.addressLine2;
            }
            addressStr +=
                ', ' + address.city + ', ' + address.province + ', ' + address.country + ' - ' + address.postalCode;
            addressesStr.push(addressStr);
        });

        return addressesStr.join(' | ');
    }
}
